<template>
  <v-card>
    <v-toolbar color="primary" class="elevation-0">
      <v-toolbar-title class="text-subtitle-1 font-weight-medium flex-0-0">Lead Times</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-select
        class="flex-0-0 mr-5"
        style="max-width: 120px"
        density="compact"
        hide-details
        v-model="selectedRegion"
        :items="regions"
      ></v-select>
    </v-toolbar>
    <v-data-table :loading="loading" :headers="headers" :items="regionalLeadTimes" hide-default-footer> </v-data-table>
  </v-card>
</template>

<script>
import { db } from '@/js/db'
import { collection, doc, getDoc, getDocs } from 'firebase/firestore'

export default {
  name: 'LeadTimes',
  data() {
    return {
      loading: true,
      leadTimes: null,
      euShippingZones: [],
      regions: [],
      selectedRegion: 'uk',
      headers: [
        {
          title: 'Item',
          key: 'item',
          sortable: false
        },
        {
          title: 'Lead',
          key: 'lead',
          sortable: false
        },
        {
          title: 'Date W/C',
          key: 'deliveryDate',
          sortable: false,
          align: 'end'
        }
      ]
    }
  },
  computed: {
    regionalLeadTimes() {
      if (this.regions.length === 0) return []
      return this.selectedRegion === 'eu' ? this.euRows() : this.standardRows()
    }
  },
  methods: {
    deliveryMoment(weeks) {
      return parseInt(this.$moment().format('d')) > 5
        ? this.$moment()
            .startOf('isoWeek')
            .add(weeks + 1, 'weeks')
        : this.$moment().startOf('isoWeek').add(weeks, 'weeks')
    },
    standardRows() {
      const region = this.leadTimes[this.selectedRegion]
      return Object.keys(region).map((key) => {
        const d = this.deliveryMoment(region[key])
        return {
          item: key.charAt(0).toUpperCase() + key.slice(1),
          lead: region[key] + ' weeks',
          deliveryDate: d.format('Do MMM') + '  / WK ' + d.week()
        }
      })
    },
    euRows() {
      const baseLead = this.leadTimes.eu.leadTime
      return this.euShippingZones.map((zone) => {
        const transit = Number(zone.transitTime) || 0
        const total = baseLead + transit
        const d = this.deliveryMoment(total)
        return {
          item: zone.name + (transit ? ` (+${transit} wk transit)` : ''),
          lead: total + ' weeks',
          deliveryDate: d.format('Do MMM') + '  / WK ' + d.week()
        }
      })
    }
  },
  async created() {
    const settings = await getDoc(doc(db, 'settings', 'mPPqOiiHvphomjk1qrI1'))
    this.leadTimes = settings.data().leadTimes
    this.regions = Object.keys(this.leadTimes)

    const zonesSnap = await getDocs(collection(db, 'shippingZones'))
    this.euShippingZones = zonesSnap.docs
      .map((d) => ({ id: d.id, ...d.data() }))
      .filter((z) => Array.isArray(z.regions) && z.regions.includes('eu'))
      .sort((a, b) => (a.name || '').localeCompare(b.name || ''))

    this.loading = false
  }
}
</script>
